import { createContext } from 'react';

export const TracingContext =  createContext ();